import { useState, useEffect, useCallback } from 'react';
/*import { useNavigate } from 'react-router-dom';*/
import { Spin, Avatar, Input, Switch, Skeleton, Empty } from 'antd';
import { UserOutlined, SearchOutlined } from '@ant-design/icons';
import moment from 'moment-timezone';
import Header from "../../../components/HeaderList";
import ZoneMap from "../../../components/customMap";
import { ReactComponent as DriverOnline } from "../../../assets/icons/driver_online.svg";
import { ReactComponent as DriverOffline } from "../../../assets/icons/driver_offline.svg";
import { ReactComponent as DriverOrder } from "../../../assets/icons/driver_withOrder.svg";
import styles from "../styles/DriversUI.module.css";


const DriversUI = (props) => {
  const {
    loading,
    /*handleLoading,*/
    drivers,
    branches,
    /*dayOrders,*/
    zoom,
    coords,
    mapcenter
  } = props;
  const [driversMarkers, setDriversMarkers] = useState([]);
  const [branchesMarkers, setBranchesMarkers] = useState([]);
  const [selectedDriverMarker, setSelectedDriverMarker] = useState(null);
  const [filter, setFilter] = useState('online');
  const [searchTerm, setSearchTerm] = useState('');
  const [showBranchesLayer, setShowBranchesLayer] = useState(true);
  const [showDriversLayer, setShowDriversLayer] = useState(true);

  const getDriversMarker = useCallback(() => {
    let markers = [];
    if (drivers.filter(x => x.available === 1).length > 0) {
      for (let drv of drivers.filter(x => x.available === 1)) {
        let lat = parseFloat(drv.latitude);
        let lng = parseFloat(drv.longitude);
        if (!isNaN(lat) && !isNaN(lng)) {
          var newMarker = {
            id: drv.id,
            title: drv.name,
            address: '',
            position: { lat, lng },
            icon: {
              url: (require("../../../assets/icons/location-driver.svg")).default,
            },
            infowindowOpen: false,
            markeroptions: {},
            orders: drv.orders
          };
          markers.push(newMarker);
        }
      }

      setDriversMarkers(markers);
    }
  }, [drivers]);

  const getBranchesMarker = useCallback(() => {
  let markers = [];
    if (branches.length > 0) {
      for (let branch of branches.filter(x => x.delivery === 1)) {
        let lat = parseFloat(branch.latitude);
        let lng = parseFloat(branch.longitude);
        if (!isNaN(lat) && !isNaN(lng)) {
          var newMarker = {
            id: branch.id,
            title: branch.zone,
            address: branch.address,
            position: { lat, lng },
  
            icon: {
              url: (require("../../../assets/icons/location-branch.svg")).default
            },
  
            infowindowOpen: false,
            markeroptions: {}
          };
          markers.push(newMarker);
        }
      }
      setBranchesMarkers(markers);
    }
  }, [branches]);

  useEffect(() => {
    getDriversMarker();
    getBranchesMarker();
  }, [drivers, branches, getDriversMarker, getBranchesMarker]);

  const onlineDrivers = drivers.filter(x => x.available === 1 && x.withActiveOrder === 0);
  const withOrderDrivers = drivers.filter(x => x.available === 1 && x.withActiveOrder === 1);
  const offlineDrivers = drivers.filter(x => x.available === 0);

  const getFilteredDrivers = () => {
    let list = [];
    if (filter === 'online') list = onlineDrivers;
    else if (filter === 'withOrder') list = withOrderDrivers;
    else if (filter === 'offline') list = offlineDrivers;

    if (searchTerm.trim() !== '') {
      list = list.filter(d => d.name.toLowerCase().includes(searchTerm.toLowerCase()));
    }
    return list;
  };

  const loadDriverMap = (driver) => {
    const marker = driversMarkers.find(m => m.id === driver.id);
    if (marker) {
      setSelectedDriverMarker(marker);
    }
  }

  const renderLayerControls = (className) => (
    <div className={className}>
      <div className={styles.layerControl}>
        <span className={styles.layerLabel}>Sucursales</span>
        <Switch size="small" checked={showBranchesLayer} onChange={setShowBranchesLayer} />
      </div>
      <div className={styles.layerControl}>
        <span className={styles.layerLabel}>Conductores</span>
        <Switch size="small" checked={showDriversLayer} onChange={setShowDriversLayer} />
      </div>
    </div>
  );

  return (
    <div className={styles.view}>
      <Header
        back="/"
        title="DRIVERS"
      />
      {loading ? (
        <div className={styles.splitLayout}>
          <div className={styles.sidebar}>
            <Skeleton.Input active block style={{ height: '40px', marginBottom: '1rem', borderRadius: '10px' }} />
            <div className={styles.filterGrid} style={{ marginBottom: '1rem' }}>
              <div className={styles.filterCard} style={{ padding: '12px' }}><Skeleton active title={false} paragraph={{ rows: 1 }} /></div>
              <div className={styles.filterCard} style={{ padding: '12px' }}><Skeleton active title={false} paragraph={{ rows: 1 }} /></div>
              <div className={styles.filterCard} style={{ padding: '12px' }}><Skeleton active title={false} paragraph={{ rows: 1 }} /></div>
            </div>
            <div className={styles.listContainer}>
              <div className={styles.driverList}>
                <div className={styles.driverCard}><Skeleton active avatar paragraph={{ rows: 1 }} /></div>
                <div className={styles.driverCard}><Skeleton active avatar paragraph={{ rows: 1 }} /></div>
                <div className={styles.driverCard}><Skeleton active avatar paragraph={{ rows: 1 }} /></div>
                <div className={styles.driverCard}><Skeleton active avatar paragraph={{ rows: 1 }} /></div>
              </div>
            </div>
          </div>
          <div className={styles.mapContainer} style={{ padding: '2rem', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Spin size="large" />
          </div>
        </div>
      ) : (
        <div className={styles.splitLayout}>
          {/* Left Sidebar */}
          <div className={styles.sidebar}>
            <Input
              placeholder="Buscar conductor..."
              prefix={<SearchOutlined style={{ color: '#bfbfbf' }} />}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              allowClear
              size="large"
              style={{ borderRadius: '10px' }}
            />

            {renderLayerControls(styles.layerControlsMobile)}

            <div className={styles.filterGrid}>
              <div className={`${styles.filterCard} ${styles.filterOnline} ${filter === 'online' ? styles.filterCardActive : ''}`} onClick={() => setFilter('online')}>
                <div className={styles.filterCardInfo}>
                  <div className={styles.filterIcon}><DriverOnline /></div>
                  <span className={styles.filterTitle}>Disponibles</span>
                </div>
                <span className={styles.filterCount}>{onlineDrivers.length}</span>
              </div>

              <div className={`${styles.filterCard} ${styles.filterWithOrder} ${filter === 'withOrder' ? styles.filterCardActive : ''}`} onClick={() => setFilter('withOrder')}>
                <div className={styles.filterCardInfo}>
                  <div className={styles.filterIcon}><DriverOrder /></div>
                  <span className={styles.filterTitle}>Con Orden</span>
                </div>
                <span className={styles.filterCount}>{withOrderDrivers.length}</span>
              </div>

              <div className={`${styles.filterCard} ${styles.filterOffline} ${filter === 'offline' ? styles.filterCardActive : ''}`} onClick={() => setFilter('offline')}>
                <div className={styles.filterCardInfo}>
                  <div className={styles.filterIcon}><DriverOffline /></div>
                  <span className={styles.filterTitle}>Inactivos</span>
                </div>
                <span className={styles.filterCount}>{offlineDrivers.length}</span>
              </div>
            </div>

            <div className={styles.listContainer}>
              <div className={styles.driverList} key={filter}>
                {getFilteredDrivers().length === 0 ? (
                  <div style={{ marginTop: '2rem' }}>
                    <Empty description="No se encontraron conductores" image={Empty.PRESENTED_IMAGE_SIMPLE} />
                  </div>
                ) : (
                  getFilteredDrivers().map(driver => (
                    <div key={driver.id} className={`${styles.driverCard} ${selectedDriverMarker?.id === driver.id ? styles.driverCardSelected : ''}`} onClick={() => loadDriverMap(driver)}>
                      <Avatar className={styles.driverAvatar} icon={<UserOutlined />}>
                        {driver.name ? driver.name.charAt(0) : ''}
                      </Avatar>
                      <div className={styles.driverInfo}>
                        <div className={styles.driverName}>
                          {driver.name}
                          <span className={`${styles.statusDot} ${styles[filter]}`} />
                        </div>
                        <span className={styles.driverTime}>
                          Actualizado: {moment(driver.updatedAt).tz('America/El_Salvador').fromNow()}
                        </span>
                        {driver.orders && driver.orders.length > 0 && (
                          <div>
                            <span className={styles.driverTicket}>
                              Ticket: {driver.orders.map(d => d.ticket).join(", ")}
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>
          </div>

          {/* Right Map */}
          <div className={styles.mapContainer}>
            <ZoneMap
              polygons={coords}
              driversMarkers={showDriversLayer ? driversMarkers : []}
              selectedDriverMarker={showDriversLayer ? selectedDriverMarker : null}
              setSelectedDriverMarker={setSelectedDriverMarker}
              branchesMarkers={showBranchesLayer ? branchesMarkers : []}
              defaultCenter={mapcenter}
              centerZoom={zoom}
              loadDraw={false}
              mapHeight="100%"
            >
              {renderLayerControls(styles.floatingControlsDesktop)}
            </ZoneMap>
          </div>
        </div>
      )}
    </div>
  );
};

export default DriversUI;